import { Component, OnInit } from '@angular/core';
import TournamentBase from '../../tournament-base';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-select-category',
    templateUrl: './select-category.component.html',
    styleUrls: ['./select-category.component.scss'],
})
export class TournamentSelectCategoryComponent implements OnInit {
    selectedCategory: string;
    constructor() {}

    ngOnInit(): void {}
}
